var activePopup;
//settings
var DEFAULT_POPUP = {
  titleStyle: new PIXI.TextStyle({
    fontFamily: "manrope-bold",
    fontSize: 42,
    fill: ["#000000"],
    align: "center",
  }),

  textStyle: new PIXI.TextStyle({
    fontFamily: "manrope-medium",
    fontSize: 36,
    fill: ["#000000"],
    align: "center",
    wordWrap: true,
    wordWrapWidth: 520,
  }),

  scrollTextStyle: new PIXI.TextStyle({
    fontFamily: "manrope-medium",
    fontSize: 36,
    fill: ["#000000"],
    align: "left",
    wordWrap: true,
    wordWrapWidth: 520,
  }),

  width: 1000,
  height: 1000,
  titleHeight: 0,
  borderRadius: 0,
  padding: 20,

  overlayFill: [0xffffff, 0.99],
  titleBgFill: [primaryPalette[1], 0],
  textBgFill: [0xffffff, 0],
  scrollBarFill: [primaryPalette[1], 0.1],

  closeBgFill: [0x000000, 0],
  closeBgHoverFill: [0x000000, 0],
  closeBgDownFill: [0x000000, 0],
  closeIconFill: [0x000000, 0],

  openAnimation: function (popup) {
    popup.overlay.alpha = 0;
    TweenMax.to(popup.overlay, 0.3, {
      pixi: {
        alpha: popup.style.overlayFill[1],
      },
    });

    //popup.window.y = -APP.screen.height * 0.5 - popup.window.height * 0.5;
    popup.content.alpha = 0;
    popup.content.scale.set(0.75);
    TweenMax.to(popup.content, 0.5, {
      pixi: {
        //y: 0
        alpha: 1,
        scale: 1,
      },
      ease: Elastic.easeOut.config(1, 1),
      delay: 0.2,
    });
  },

  closeAnimation: function (popup) {
    TweenMax.to(popup.overlay, 0.5, {
      pixi: {
        alpha: 0,
      },
      delay: 0.2,
      ease: Power2.easeIn,
      onComplete: function () {
        activePopup = null;
        popup.delete();
        if (popup.closeCallback) {
          popup.closeCallback();
        }
      },
    });

    TweenMax.to(popup.content, 0.5, {
      pixi: {
        //y: -APP.screen.height * 0.5 - popup.window.height * 0.5
        alpha: 0,
        scale: 0.75,
      },
      ease: Elastic.easeIn.config(1, 1),
    });
  },
};

var SMALL_POPUP = JSON.parse(JSON.stringify(DEFAULT_POPUP));
SMALL_POPUP.height = 300;

var LARGE_POPUP = JSON.parse(JSON.stringify(DEFAULT_POPUP));
LARGE_POPUP.height = 900;

///////////////////

function alertPopup(titleKey, textKey, onCloseCallback, style) {
  var popup = new Container(APP.stage);
  style = style || DEFAULT_POPUP;
  popup.style = style;
  popup.closeCallback = onCloseCallback;
  var title = getText(titleKey) || titleKey;
  var text = getText(textKey) || textKey;

  popup.overlay = new WhiteRectangle(popup, [APP.screen.width, APP.screen.height]);
  popup.overlay.tint = style.overlayFill[0];
  popup.overlay.alpha = style.overlayFill[1];
  popup.overlay.interactive = true;

  popup.window = new Container(popup);

  popup.textBoxBg = new Rectangle(popup.window, [style.width, style.height, style.borderRadius], [0, 0], [0xffffff, 1]);
  popup.textBoxBg.tint = style.textBgFill[0];
  popup.textBoxBg.alpha = style.textBgFill[1];

  popup.content = new Container(popup.window);

  popup.textBox = new Text(popup.content, text, style.textStyle);
  popup.textBox.position.set(0, style.titleHeight / 2);

  if (popup.content.height > style.height - style.titleHeight) {
    popup.textBox.style = style.scrollTextStyle;
    popup.textBox.anchor.set(0.5, 0);
    popup.textBox.y = -style.height * 0.5 + style.titleHeight + style.padding + style.borderRadius / 2;
    popup.contentMask = new WhiteRectangle(popup.window, [style.width, style.height - style.titleHeight - (style.borderRadius + 4)]);
    popup.contentMask.anchor.set(0);
    popup.contentMask.setTransform(-style.width / 2, -style.height / 2 + style.titleHeight + (style.borderRadius + 4) / 2);

    makeScrollable(popup.content, popup.contentMask, style.padding * 2, style.scrollBarFill[0]);
    popup.content.scrollBar.alpha = style.scrollBarFill[1];
  }

  popup.titleMask = new Rectangle(popup.window, [style.width, style.height, style.borderRadius], null, null, true);
  popup.titleMask.anchor.set(0);
  popup.titleMask.position.set(-style.width / 2, -style.height / 2);

  popup.titleBg = new Rectangle(popup.window, [style.width, style.titleHeight]);
  popup.titleBg.y = -(style.height - style.titleHeight) * 0.5;
  popup.titleBg.tint = style.titleBgFill[0];
  popup.titleBg.alpha = style.titleBgFill[1];
  popup.titleBg.mask = popup.titleMask;

  popup.closeBg = new Rectangle(popup.window, [style.titleHeight, style.titleHeight]);
  popup.closeBg.position.set((style.width - style.titleHeight) * 0.5, -(style.height - style.titleHeight) * 0.5);
  popup.closeBg.tint = style.closeBgFill[0];
  popup.closeBg.alpha = style.closeBgFill[1];
  popup.closeBg.mask = popup.titleMask;

  popup.titleText = new Text(popup.window, title, style.titleStyle);
  popup.titleText.position.set(0, -style.height / 2 + style.titleHeight / 2);

  popup.closeIcon = new Container(popup.window);
  var line1 = new Rectangle(popup.closeIcon, [4, style.titleHeight * 0.66, 0], [0], [0xffffff, 1]);
  line1.position = popup.closeBg.position;
  line1.rotation = degToRad(45);
  var line2 = new Rectangle(popup.closeIcon, [4, style.titleHeight * 0.66, 0], [0], [0xffffff, 1]);
  line2.position = popup.closeBg.position;
  line2.rotation = degToRad(-45);

  line1.tint = style.closeIconFill[0];
  line1.alpha = style.closeIconFill[1];
  line2.tint = style.closeIconFill[0];
  line2.alpha = style.closeIconFill[1];

  makeInteractive(popup.closeBg, "pointerup", function () {
    popup.closeBg.tint = style.closeBgFill[0];
    popup.closeBg.alpha = style.closeBgFill[1];
    line1.scale.set(1);
    line2.scale.set(1);
    popup.closeBg.interactive = false;
    closePopup();
  });
  makeInteractive(popup.closeBg, "mouseover", function () {
    popup.closeBg.tint = style.closeBgHoverFill[0];
    popup.closeBg.alpha = style.closeBgHoverFill[1];
  });
  makeInteractive(popup.closeBg, "mouseout", function () {
    popup.closeBg.tint = style.closeBgFill[0];
    popup.closeBg.alpha = style.closeBgFill[1];
    line1.scale.set(1);
    line2.scale.set(1);
  });
  makeInteractive(popup.closeBg, "pointerdown", function () {
    popup.closeBg.tint = style.closeBgDownFill[0];
    popup.closeBg.alpha = style.closeBgDownFill[1];
    line1.scale.set(0.95);
    line2.scale.set(0.95);
  });

  if (popup.style.openAnimation) popup.style.openAnimation(popup);

  activePopup = popup;
  resizePopup();

  return popup;
}

function confirmPopup(titleKey, textKey, btnTexts, callbacks, style, buttonStyle) {
  style = style || SMALL_POPUP;
  buttonStyle = buttonStyle || POPUP_BUTTON;
  var popup = alertPopup(titleKey, textKey, null, style);

  function f(i) {
    callbacks[i]();
    popup.buttons[0].interactive = false;
    popup.buttons[1].interactive = false;
    closePopup();
  }
  popup.buttons = [];
  popup.buttons[0] = new Button(
    popup.content,
    btnTexts[0],
    "",
    function () {
      f(0);
    },
    buttonStyle
  );

  popup.buttons[1] = new Button(
    popup.content,
    btnTexts[1],
    "",
    function () {
      f(1);
    },
    buttonStyle
  );

  var buttonPadding = (popup.style.width - 2 * buttonStyle.width) / 3;
  popup.buttons[0].x = -buttonPadding / 2 - buttonStyle.width / 2;
  popup.buttons[1].x = buttonPadding / 2 + buttonStyle.width / 2;

  if (!popup.content.scrollable) {
    popup.buttons[0].y = popup.style.height * 0.5 - popup.buttons[0].height * 0.5 - buttonPadding;
    popup.buttons[1].y = popup.style.height * 0.5 - popup.buttons[0].height * 0.5 - buttonPadding;

    popup.textBox.y -= (popup.buttons[0].height + 20) * 0.5;
  } else {
    var btnY = popup.content.height;
    popup.buttons[0].y = btnY;
    popup.buttons[1].y = btnY;
    updateScroll(popup.content, popup.contentMask, style.padding * 2);
  }
  return popup;
}

function closePopup() {
  if (!activePopup) return;

  var popup = activePopup;

  if (popup.style.closeAnimation) {
    popup.style.closeAnimation(popup);
  } else {
    activePopup = null;
    popup.delete();
  }
}

function resizePopup() {
  if (activePopup != undefined) {
    activePopup.overlay.width = APP.screen.width;
    activePopup.overlay.height = APP.screen.height;
    activePopup.position.set(APP.screen.width / 2, APP.screen.height / 2);
    activePopup.window.scale.set(ratio_scale);
  }
}

resize_methods.push(resizePopup);
